module.exports = __webpack_public_path__ + "img/gwyx-zyzyfc.3435a5c7.png";